export const roleIncumbentSelector = (state) => state.user.roleActive.roleId;
